export const emailRegEx =
  /^[A-Za-z0-9]([._-]?[A-Za-z0-9]+)*@[A-Za-z0-9]([._-]?[A-Za-z0-9]+)*\.[A-Za-z]{2,}$/i;
export const passwordRegEx =
  /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*?_]{8,20}$/;
